export default {
  'SLModal.default.okText': '完成',
  'SLModal.default.cacelText': '取消',
  'SLModal.info.okText': '我知道了'
};